var scope_0 = require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5764e9738ba19c3537cc3c51b263df33.js').default;
var scope_1 = require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d92ab750aa9744cb8b3a2051abd78ff5.js').default;
var scope_2 = require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fbb42bf7d2839129bd98a1bd48ae431e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    